var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 4.25H3.54167H14.875",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 4.25002V2.83335C5.6665 2.45763 5.81576 2.0973 6.08144 1.83162C6.34711 1.56594 6.70745 1.41669 7.08317 1.41669H9.9165C10.2922 1.41669 10.6526 1.56594 10.9182 1.83162C11.1839 2.0973 11.3332 2.45763 11.3332 2.83335V4.25002M13.4582 4.25002V14.1667C13.4582 14.5424 13.3089 14.9027 13.0432 15.1684C12.7776 15.4341 12.4172 15.5834 12.0415 15.5834H4.95817C4.58245 15.5834 4.22211 15.4341 3.95644 15.1684C3.69076 14.9027 3.5415 14.5424 3.5415 14.1667V4.25002H13.4582Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 7.79169V12.0417",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9165 7.79169V12.0417",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.732c99f6529c499b601779cff66d5e47.svg";
export { ForwardRef as ReactComponent };